import fetch from 'isomorphic-fetch'
import { authHeader, handleResponse } from './helpers'
import { API_URL } from '../../constants/Config'

export const datasetsService = {
  getDatasets,
  getOneDataset,
  createDataset,
  updateEventsConfig,
  reload,
  enableWorkflows,
  getWorkflows,
  createWorkflow,
  getOneWorkflow,
  updateWorkflow,
  removeWorkflow,
  getUsage,
  getTeamMembers,
  updateMember,
  getAllLanguages,
  getTaxonomy,
  updateTaxonomy,
  updateLoadingConfig,
}

async function getDatasets(auth_token) {
  const url = `${API_URL}/datasets`
  const options = {
    method: 'GET',
    headers: authHeader(auth_token),
  }
  return fetch(url, options)
    .then(response => handleResponse(response))
    .then(response => response.datasets)
}

async function getOneDataset(auth_token, dataset_id) {
  const url = `${API_URL}/datasets/${dataset_id}`
  const options = {
    method: 'GET',
    headers: authHeader(auth_token),
  }
  return fetch(url, options).then(response => handleResponse(response))
}

async function createDataset(auth_token, name, source, load, product, data_points) {
  const url = `${API_URL}/datasets?load=${load}&product=${product}`
  const options = {
    method: 'POST',
    headers: authHeader(auth_token, {
      'Content-Type': 'application/json',
    }),
    body: JSON.stringify({ name, source, data_points }),
  }
  return fetch(url, options).then(response => handleResponse(response))
}

async function updateEventsConfig(auth_token, dataset_id, events_app, config) {
  const url = `${API_URL}/datasets/${dataset_id}/events/${events_app}`
  const options = {
    method: 'PUT',
    headers: authHeader(auth_token, {
      'Content-Type': 'application/json',
    }),
    body: JSON.stringify(config),
  }
  return fetch(url, options).then(response => handleResponse(response))
}

async function reload(auth_token, dataset_id, product, brand_id) {
  const url = `${API_URL}/datasets/${dataset_id}/tasks/load`
  const options = {
    method: 'POST',
    headers: authHeader(auth_token, {
      'Content-Type': 'application/json',
    }),
    body: JSON.stringify({ product, ...(brand_id != null && { brand_id }) }),
  }
  return fetch(url, options).then(response => handleResponse(response))
}

async function enableWorkflows(auth_token, dataset_id, product, enable) {
  const url = `${API_URL}/datasets/${dataset_id}/events/${product}`
  const options = {
    method: 'PUT',
    headers: authHeader(auth_token, {
      'Content-Type': 'application/json',
    }),
    body: JSON.stringify({enabled: enable}),
  }
  return fetch(url, options).then(response => handleResponse(response))
}

async function getWorkflows(auth_token, dataset_id, product) {
  let url = `${API_URL}/datasets/${dataset_id}/workflows?product=${product}`
  const options = {
    method: 'GET',
    headers: authHeader(auth_token),
  }
  return fetch(url, options).then(response => handleResponse(response))
}

async function createWorkflow(auth_token, dataset_id, product, workflow) {
  const url = `${API_URL}/datasets/${dataset_id}/workflows?product=${product}`
  const options = {
    method: 'POST',
    headers: authHeader(auth_token, {
      'Content-Type': 'application/json',
    }),
    body: JSON.stringify(workflow),
  }
  return fetch(url, options).then(response => handleResponse(response))
}

async function getOneWorkflow(auth_token, dataset_id, workflow_id) {
  const url = `${API_URL}/datasets/${dataset_id}/workflows/${workflow_id}`
  const options = {
    method: 'GET',
    headers: authHeader(auth_token),
  }
  return fetch(url, options).then(response => handleResponse(response))
}

async function updateWorkflow(auth_token, dataset_id, product, workflow_id, workflow) {
  const url = `${API_URL}/datasets/${dataset_id}/workflows/${workflow_id}?product=${product}`
  const options = {
    method: 'PUT',
    headers: authHeader(auth_token, {
      'Content-Type': 'application/json',
    }),
    body: JSON.stringify(workflow),
  }
  return fetch(url, options).then(response => handleResponse(response))
}

async function removeWorkflow(auth_token, dataset_id, product, workflow_id) {
  const url = `${API_URL}/datasets/${dataset_id}/workflows/${workflow_id}?product=${product}`
  const options = {
    method: 'DELETE',
    headers: authHeader(auth_token),
  }
  return fetch(url, options).then(response => handleResponse(response))
}

async function getUsage(auth_token, dataset_id, query) {
  const url = `${API_URL}/datasets/${dataset_id}/app_usage?${new URLSearchParams(query)}`
  const options = {
    method: 'GET',
    headers: authHeader(auth_token),
  }
  return fetch(url, options).then(response => handleResponse(response))
}

async function getTeamMembers(auth_token, dataset_id, query) {
  const url = `${API_URL}/datasets/${dataset_id}/team-members`
  const options = {
    method: 'GET',
    headers: authHeader(auth_token),
  }
  return fetch(url, options).then(response => handleResponse(response))
}

async function updateMember(auth_token, dataset_id, member_id, member) {
  const url = `${API_URL}/datasets/${dataset_id}/update-member/${member_id}`
  const options = {
    method: 'PUT',
    headers: authHeader(auth_token, {
      'Content-Type': 'application/json',
    }),
    body: JSON.stringify(member),
  }
  return fetch(url, options).then(response => handleResponse(response))
}

async function getTaxonomy(auth_token, dataset_id) {
  const url = `${API_URL}/datasets/${dataset_id}/taxonomy`
  const options = {
    method: 'GET',
    headers: authHeader(auth_token),
  }
  return fetch(url, options).then(response => handleResponse(response))
}

async function updateTaxonomy(auth_token, dataset_id, taxonomy) {
  const url = `${API_URL}/datasets/${dataset_id}/taxonomy`
  const options = {
    method: 'PUT',
    headers: authHeader(auth_token, {
      'Content-Type': 'application/json',
    }),
    body: JSON.stringify(taxonomy),
  }
  return fetch(url, options).then(response => handleResponse(response))
}

async function getAllLanguages(auth_token, dataset_id) {
  const url = `${API_URL}/datasets/${dataset_id}/all-languages`
  const options = {
    method: 'GET',
    headers: authHeader(auth_token),
  }
  return fetch(url, options).then((response) => handleResponse(response))
}


async function updateLoadingConfig(auth_token, dataset_id, config) {
  const url = `${API_URL}/datasets/${dataset_id}/loading`
  const options = {
    method: 'PUT',
    headers: authHeader(auth_token, {
      'Content-Type': 'application/json',
    }),
    body: JSON.stringify(config),
  }
  return fetch(url, options).then((response) => handleResponse(response))
}
